import {
  ACTIVITY_META_FETCHED,
  LOADING_ACTIVITY_STOPPED,
  LOADING_ACTIVITY_STARTED,
  NEXT_ACTIVITY_SET,
  IS_MARKED_SET,
  STUDENT_ANSWER_UPDATED,
  CONQUEST_USER_RESPONSE_REMOVED,
  CONQUEST_RESET
} from './conquest.actions';

const initialState = {
  activityIndex: 0,
  isLoading: true,
  isMarked: false,
  conquestData: null,
  conquestMeasurementTools: null,
  conquestUserResponse: null,
  conquestValidation: null,
  conquestQuestionId: null,
  conquestUserAnswer: null,
  conquestIsReady: false,
  girlId: ''
};

const conquestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVITY_META_FETCHED:
      return {
        ...state,
        conquestData: action.data.conquest.questionVariant.questionItem.questionContent.content,
        conquestMeasurementTools: action.data.conquest.questionVariant.questionItem.measurementTool,
        conquestUserResponse: action.data.validation.studentAnswer,
        conquestValidation: action.data.validation.validationResult,
        conquestQuestionId: action.data.conquest.questionVariant.id,
        girlId: action.data.girlId
      };

    case LOADING_ACTIVITY_STOPPED:
      return {
        ...state,
        isLoading: false
      };

    case LOADING_ACTIVITY_STARTED:
      return {
        ...state,
        isLoading: true
      };

    case NEXT_ACTIVITY_SET:
      return {
        ...state,
        activityIndex: action.nextIndex
      };

    case IS_MARKED_SET:
      return {
        ...state,
        isMarked: action.isMarked
      };

    case STUDENT_ANSWER_UPDATED:
      return {
        ...state,
        ...action.payload
      };

    case CONQUEST_USER_RESPONSE_REMOVED:
      return {
        ...state,
        conquestUserAnswer: null,
        conquestIsReady: false
      };

    case CONQUEST_RESET:
      return {
        ...state,
        conquestUserResponse: null,
        conquestValidation: null,
        conquestUserAnswer: null,
        conquestIsReady: false
      };

    default:
      return state;
  }
};

export default conquestReducer;
